module.exports = __webpack_public_path__ + "static/media/short-hit.a7c42e2c.png";